(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[396],{

/***/ 5399:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy",
      function () {
        return __webpack_require__(9523);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ TopSpacing; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5992);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var TopSpacing = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        width: "100%",
        height: 240
    }, _defineProperty(_obj, theme.breakpoints.down("xl"), {
        height: 200
    }), _defineProperty(_obj, theme.breakpoints.down("md"), {
        height: 160
    }), _defineProperty(_obj, theme.breakpoints.down("sm"), {
        height: 120
    }), _obj;
});


/***/ }),

/***/ 9523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8675);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2197);
/* harmony import */ var components_SongStarterHeader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2847);
/* harmony import */ var components_TopSpacing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6576);
/* harmony import */ var components_Footer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2620);






function PrivacyVoorwaarden() {
    var pageTitle = "Privacy policy";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: pageTitle
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SongStarterHeader__WEBPACK_IMPORTED_MODULE_2__/* .SongStarterHeader */ .L$, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                maxWidth: "md",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "h2",
                        component: "h1",
                        gutterBottom: true,
                        style: {
                            color: "#fff"
                        },
                        children: pageTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "h6",
                        gutterBottom: true,
                        children: "SongStarter - Privacy Policy"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: "Effective Date:\xa0September 22st 2021"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "h6",
                        gutterBottom: true,
                        children: "Privacy Policy"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: "Our company, SongStarter (trademark of Tribe Music B.V.) (hereinafter: \u201CSongStarter\u201D) operates https://songstarter.com (hereinafter: \u201Cthe Site\u201D). This privacy policy applies to anyone who uses the site."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "h6",
                        gutterBottom: true,
                        children: "Your Consent"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: "By using our site, you consent to our privacy policy."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "h6",
                        gutterBottom: true,
                        children: "Personal Information Collection"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: "While using the Site and any of its activities, applications, features, services and resources, we may ask you to provide some personal identification information that can be used to interact with the Site or identify you (hereinafter: \u201CPersonal Information\u201D). Information may also be collected in a variety of ways including, but not limited to, when you visit the Site, subscribe to any of its services, contact us, download music, complete a form and any other activity performed by you on the site. The personal information may include, but is not limited to, your full name, mailing address, email address and personal identification number. You may refuse to provide us with Personal Information, but it is possible that without the information, you will not be able to make use of the Site and/or some of its functions. We are entitled to collect and use information relating to your use of musical works contained in the repertoire of the Site, including, but not limited to, musical works you have heard and/or downloaded from the site (including their frequency, quantity, times and dates). You acknowledge that this information is collected automatically while you hear or download any musical work from the site and agree to this."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "h6",
                        gutterBottom: true,
                        children: "Non-Personal Identification Information"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: "We may collect information that your browser sends whenever you visit our Site. This data may include information such as your computer\u2019s Internet Protocol address, browser type, browser version, operating system, which pages of our Site that you visit, the time and date of your visit, the time spent on those pages and other statistics."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "h6",
                        gutterBottom: true,
                        children: "Communications"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: "We may use your Personal Information to contact you with periodical emails which include newsletters, updates, marketing or promotional materials, company news or service information, etc. If at any time you would like to unsubscribe from receiving future emails, we include detailed unsubscribe instructions at the bottom of each email."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "h6",
                        gutterBottom: true,
                        children: "Cookies"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: [
                            "We may use \u201Ccookies\u201D. Cookies are small files that are sent to your computer through your browser. The cookies are stored on your computer\u2019s hard drive for record saving purposes and may enable the Site to recognize your browser and track certain information relating to your visit in the Site. We use cookies in order to identify users and allow registered users more convenient access to the services provided by the Site, and also in order to understand user\u2019s preferences and improve our Site. You can instruct your web browser to refuse cookies or to alert you when a cookie is being sent. If you do not accept cookies, you may not be able to use functions of our Site. What do we use the information for? ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "We may use any of the information we collect from you for any of the following purposes:"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: "\u2022 To personalize user experience."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: "\u2022 To improve our Site."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: "\u2022 To improve our customer service."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: "\u2022 To process payments."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: "\u2022 To contact you."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: "\u2022 To send you updates, company information, promotional information etc. (as mentioned above). \u2022 To respond to your questions and / or inquiries."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: "\u2022 To administer contests, promotions, surveys or other Site features."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "h6",
                        gutterBottom: true,
                        children: "Information Security"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: "The security of your Personal Information is important to us. We take the necessary technological measures to protect against unauthorized access, disclosure or use of your personal information stored on our site."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "h6",
                        gutterBottom: true,
                        children: "Disclosure of information to other parties"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: "We do not transfer information collected by the Site to outside parties and do not disclose it. The foregoing does not derogate from the right granted to us to disclose or to give the information to outside parties who assist us in operating the Site and/or provide the Site with services of any kind, subject to their obligation to keep the information confidential. We may also release your information when we believe release is appropriate to comply with the law, enforce our site policies, or protect ours or others rights, property or safety."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "h6",
                        gutterBottom: true,
                        children: "Third-Party Links"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: "We may include in our Site advertising or other content that link to other sites or services of third parties. These third-party sites have separate and independent privacy policies and we have no responsibility or liability for the content and activities of these linked sites."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "h6",
                        gutterBottom: true,
                        children: "Changes To This Privacy Policy"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: "We reserve the right to update or change this Privacy Policy at our sole discretion at any time. Any changes in this Privacy Policy will be in effect immediately after being posted by us on this page. Your continued use of the Site after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "h6",
                        gutterBottom: true,
                        children: "Terms and Conditions"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: "Please also visit our terms and conditions section establishing the use, disclaimers and limitations of liability governing the use of our website at https://songstarter.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "h6",
                        gutterBottom: true,
                        children: "Applicable Law"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: "The laws of the Netherlands will apply exclusively to the Site\u2019s privacy policy."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "h6",
                        gutterBottom: true,
                        children: "Contact Us"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body1",
                        color: "textSecondary",
                        gutterBottom: true,
                        children: [
                            "If you have any questions regarding this privacy policy, you may contact us using the information below. SongStarter (Tribe Music B.V.)",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "Retentieweg 24",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "7572 PH, Oldenzaal",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "The Netherlands",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "info@songstarter.com"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_TopSpacing__WEBPACK_IMPORTED_MODULE_3__/* .TopSpacing */ .O, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Footer__WEBPACK_IMPORTED_MODULE_4__/* .Footer */ .$, {})
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (PrivacyVoorwaarden);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [90,164,774,888,179], function() { return __webpack_exec__(5399); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);